export interface EntryData {
  productUrl?: string;
  imageUrl?: string;
  partNumber?: string;
  sapNetPrice?: string;
  customerStock?: string | number;
  productCode: string;
  name?: string;
  price?: string;
  quantity: number;
  roundingQuantity: number;
  blocked?: boolean;
  showAddToCartButton?: boolean;
}

export interface OrderTemplateInterface {
  code: string;
  name?: string;
  description?: string;
  orderTemplateEntries: EntryData[];
}

export class OrderTemplate implements OrderTemplateInterface {

  private static endpoint = `${window.ACC.config.encodedContextPath}/orderTemplates`;

  constructor(
    public code: string,
    public name?: string,
    public description?: string,
    public orderTemplateEntries: EntryData[] = [],
  ) {
  }

  static create(name: string, createFromCart = false): JQuery.jqXHR {
    const { CSRFToken } = window.ACC.config;
    return $.ajax({
      url: OrderTemplate.endpoint,
      method: 'POST',
      data: {
        name,
        createFromCart,
        CSRFToken,
      },
    });
  }

  static getProduct(code: string): JQuery.jqXHR {
    return $.ajax({
      url: `${window.ACC.config.encodedContextPath}/nosolr/productWithStockPrice?code=${encodeURIComponent(code)}`,
      type: 'GET',
    });
  }

  static createFromCart = (name) => OrderTemplate.create(name, true);

  setName(name: string): void {
    this.name = name;
  }

  setDescription(description: string): void {
    this.description = description;
  }

  getName(): string | undefined {
    return this.name;
  }

  getCode(): string {
    return this.code;
  }

  getEntries(): EntryData[] {
    return this.orderTemplateEntries;
  }

  setEntries(newEntries: EntryData[]): void {
    this.orderTemplateEntries = newEntries;
  }

  removeEntry(index: number): void {
    if (this.orderTemplateEntries[index] === undefined) {
      throw new Error(`No order template entry found at ${index}`);
    }
    this.orderTemplateEntries.splice(index, 1);
  }

  setProductQuantity(index: number, quantity: number): void {
    this.orderTemplateEntries[index].quantity = quantity;
  }

  addProduct(product: EntryData): void {
    this.orderTemplateEntries.push(product);
  }

  clearProductEntries(): void {
    this.orderTemplateEntries = [];
  }

  duplicate(duplicateName: string): JQuery.jqXHR {
    return $.ajax({
      url: OrderTemplate.endpoint,
      method: 'POST',
      data: {
        name: duplicateName,
        code: this.getCode(),
        CSRFToken: window.ACC.config.CSRFToken,
      },
    });
  }

  delete(): JQuery.Promise<any> {
    return $.ajax({
      url: `${OrderTemplate.endpoint}/${this.getCode()}`,
      method: 'DELETE',
    });
  }

  save(): JQuery.jqXHR {
    return $.ajax({
      url: `${OrderTemplate.endpoint}/${this.getCode()}`,
      type: 'PUT',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: this.toJSON(),
    });
  }

  toJSON(): string {
    return JSON.stringify({
      code: this.code,
      name: this.name,
      description: this.description,
      orderTemplateEntries: this.orderTemplateEntries,
    });
  }

}
